export const TRY_FETCH_RESOURCE = 'tryFetchResource';
export const SET_RESOURCE = 'setResource';